/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deploymentsRedeployDeployment } from "../funcs/deploymentsRedeployDeployment.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RedeployResult } from "../models/components/redeployresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  RedeployDeploymentRequest,
  RedeployDeploymentSecurity,
} from "../models/operations/redeploydeployment.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RedeployDeploymentMutationVariables = {
  request: RedeployDeploymentRequest;
  security?: RedeployDeploymentSecurity | undefined;
  options?: RequestOptions;
};

export type RedeployDeploymentMutationData = RedeployResult;

export type RedeployDeploymentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * redeploy deployments
 *
 * @remarks
 * Redeploys an existing deployment.
 */
export function useRedeployDeploymentMutation(
  options?: MutationHookOptions<
    RedeployDeploymentMutationData,
    RedeployDeploymentMutationError,
    RedeployDeploymentMutationVariables
  >,
): UseMutationResult<
  RedeployDeploymentMutationData,
  RedeployDeploymentMutationError,
  RedeployDeploymentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRedeployDeploymentMutation(client, options),
    ...options,
  });
}

export function mutationKeyRedeployDeployment(): MutationKey {
  return ["@gram/client", "deployments", "redeployDeployment"];
}

export function buildRedeployDeploymentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RedeployDeploymentMutationVariables,
  ) => Promise<RedeployDeploymentMutationData>;
} {
  return {
    mutationKey: mutationKeyRedeployDeployment(),
    mutationFn: function redeployDeploymentMutationFn({
      request,
      security,
      options,
    }): Promise<RedeployDeploymentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(deploymentsRedeployDeployment(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
